// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"41ef0564","725":"41ef0564","857":"ea60ed96"}[chunkId] + ".chunk.css";
};